<div class="product-sdsn-container"
     [ngClass]="{'recommended': shopWindowItem.preferred}">

    <div class="header" [ngClass]="{'recommended': shopWindowItem.preferred, 'notRecommended': !shopWindowItem.preferred}"
         >
        <span class="recommendedText" *ngIf="shopWindowItem.preferred; else notRecommended">Recomendado</span>
        <ng-template #notRecommended>
            <span class="notRecommendedText"></span>
        </ng-template>
    </div>
    <div class="card">

        <div class="planName">
            <p class="name">{{shopWindowItem.cardTitle}}</p>
            <p class="detail">{{this.periodicity}}</p>
        </div>
        <div class="planPrice">
            <span class="totalValue" *ngIf="isAppliedDiscounts()">
                De <span class="censored">R$ {{getValue('baseValue')}}</span> por:
            </span>
            <span class="currencyPerMonth">
                <strong>R$ {{getValue('monthlyValue')}}</strong> / mês
            </span>
            <span class="price">
                <strong>R$ {{getValue('totalValue')}}</strong> {{this.getPeriodicityLabel()}}
            </span>
        </div>
        <div class="button">
            <button  (click)="onClick()">
                <span class="buttonText">{{shopWindowItem.buttonName}}</span>
            </button>
        </div>
    </div>
</div>
